import React from 'react';
import { Trans } from '@lingui/macro';
import styled from 'styled-components/native';

import FontIcon from '@src/components/FontIcon';
import { Body2, H1, H2 } from '@src/components/Typography';
import { padding } from '@src/configuration/constants';

type Props = {
  onMorePress?: () => void;
  children: React.ReactNode;
  titleSuffixPlus?: string;
  titlePlus?: string;
  titleTop?: string;
};

const Container = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 ${padding}px ${padding / 2}px;
`;

const MoreButton = styled.TouchableOpacity`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: ${({ theme }) => theme.roundness / 2}px;
  border-color: ${({ theme }) => theme.colors.primary};
  padding-top: ${padding / 2}px;
  padding-bottom: ${padding / 2}px;
  padding-left: 11px;
  padding-right: 11px;
  border-width: 1px;
`;
const Row = styled.View`
  flex-direction: row;
  align-items: center;
`;
const Label = styled(Body2)`
  color: ${({ theme }) => theme.colors.primary};
  margin: 0 5px;
`;

const Plus = styled(FontIcon).attrs(({ theme }) => ({
  name: 'plus',
  color: theme.colors.primary,
}))`
  align-self: center;
  position: absolute;
  top: -8;
  left: 0;
  right: 2px;
`;
const H1Title = styled(H2)`
  font-weight: 700 !important;
`;
export const H1Plus = styled(H2).attrs({
  dir: 'unset',
})`
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 700 !important;
`;
const Component: React.FC<Props> = ({
  children,
  titleTop,
  titleSuffixPlus,
  titlePlus,
  onMorePress,
}) => {
  return (
    <Container>
      {titleSuffixPlus ? (
        <Row>
          {titleTop ? (
            <H1Title>{titleTop}</H1Title>
          ) : (
            <H1Title>{children}</H1Title>
          )}
          <H1Plus>{titlePlus}</H1Plus>
          <Plus />
          <H1Title>{titleSuffixPlus}</H1Title>
        </Row>
      ) : (
        <H1Title>{children}</H1Title>
      )}
      {onMorePress && (
        <MoreButton onPress={onMorePress}>
          <Label>
            <Trans>View All</Trans>
          </Label>
          {/* <Icon /> */}
        </MoreButton>
      )}
    </Container>
  );
};

Component.displayName = 'Title';

export default React.memo(Component);
